import SectionBanner from '@common/components/SectionBanner';
import React from 'react';
import Product from './components/Product';
import SeoPages from '../../../common/assets/json/seo_pages.json';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const featuresData = [
    {
        id: 1,
        icon: 'quality',
        title: 'Certified <br/> Quality'
    },
    {
        id: 2,
        icon: 'washable',
        title: 'Washable & <br/> Resilient'
    },
    {
        id: 3,
        icon: 'non-toxic',
        title: 'Safe & <br/> Non-Toxic'
    },
    {
        id: 4,
        icon: 'sustainably',
        title: 'Sustainable <br/>Management <br/>Practices'
    },
    {
        id: 5,
        icon: 'social',
        title: 'Social <br/> Responsibility'
    },
    {
        id: 6,
        icon: 'touch',
        title: 'Exceptional <br/> Touch'
    }
];

function CurtainsTemplate() {
    const location = useLocation();
    const pathname = location.pathname.replace(/^\/+/, ''); // e.g., "/pathname1"
    const pageData = SeoPages[pathname] || {};

    return (
        <>
            {Object.keys(pageData).length <= 0 ? (
                <div>Loading...</div>
            ) : (<>
                <div className='bs-section cm-no-padding bs-section--typ-grey '>
                    <div className='bs-section__section-cont'>
                        <SectionBanner
                            noHover
                            titleLine1={pageData?.category_name}
                            titleLine2={pageData?.category_title}
                            variant='typ-4'
                            imageUrl={pageData?.category_banner_img}
                            btnText={pageData?.btn_text}
                            btnLink={pageData?.btn_link}
                        // desc="Style your home with our consciously crafted window curtains, thoughtfully designed for every space — from curtains for living room to curtains for bedroom and more. Made for modern living, our collection features everything from elegant sheer curtains for living room to light-blocking blackout curtains for bedroom. "
                        />
                    </div>
                </div>
                <div className='bs-section bs-section--typ-grey lyt-fabrication-list'>
                    <div className='bs-section__section-head lyt-fabrication-list__head-wrap'>
                        <h2 className='bs-section__title'>{pageData?.paragraph_title}</h2>
                        <p className='bs-section__desc'>{pageData?.paragraph}</p>
                        <span className='icon icon-curtain bs-section__title-icon lyt-fabrication-list__title-icon'></span>
                    </div>
                    {pageData.collection_list.length > 0 && (
                        <div className='bs-section__section-cont lyt-fabrication-list__cont-wrap'>
                            <Product data={pageData?.collection_list} />
                        </div>
                    )}
                </div>
                <div className='bs-section lyt-features-section'>
                    <div className='bs-section__section-head lyt-features-section__head-wrap'>
                        <h2 className='bs-section__title'>Beauty Woven with Purpose</h2>
                        <p className='bs-section__desc bs-section__desc--typ-sm'>From effortless drape to light control, each Sansaar curtain carries features designed for comfort, elegance, and a refined living experience.</p>
                    </div>
                    <div className='bs-section__section-cont lyt-features-section__cont-wrap'>
                        <div className="lyt-features">
                            {featuresData?.map((ele, index) => {
                                return (
                                    <div className='mod-icon-info mod-icon-info--typ-bg' key={index}>
                                        <div className='mod-icon-info__icon-wrap'>
                                            <span className={`icon icon-${ele.icon}`}></span>
                                        </div>
                                        <div className='mod-icon-info__info-wrap'>
                                            <p className='mod-icon-info__desc' dangerouslySetInnerHTML={{ __html: ele.title }}></p>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </>)}
        </>
    )
}

export default CurtainsTemplate